export const TwitterIcon = (props: React.ComponentPropsWithoutRef<"svg">) => {
	return (
		<svg viewBox="0 0 27 22" {...props}>
			<use href="/images/icons.svg#vlw-twitter" />
		</svg>
	)
}
